<template>
    <div id="app">
        <marquee-3k :speed="1.2" :reverse="true" class="top-marquee" ref="topMarquee">
            WELCOME ††† UNVEIL THE TRUTH ††† FREE FONT ††† FREE TYPE TAROT READING ††† DISCOVER YOUR DESTINY ††† NO CB NO BS †††
        </marquee-3k>
        <div class="app-wrapper" ref="appWrapper">
            <intro v-if="!hasSeenIntro" @done="onIntroIsDone"/>
            <keep-alive v-else>
                <router-view ref="view" :introCardPos="introCardPos"/>
            </keep-alive> 
        </div>
        <marquee-3k :speed="1.2" :reverse="true" class="bottom-marquee" ref="bottomMarquee">
            <a :href="downloadLink" download>CLICK HERE TO DOWNLOAD THE FONT /!\ </a>
        </marquee-3k>
    </div>
</template>

<script>
import Marquee3k from '@/components/ui/Marquee3k';
import Intro from '@/components/Intro2';


export default {

    components: {Intro, Marquee3k},

    data () {return {
        hasSeenIntro: false,
        introCardPos: null,
        downloadLink: window.location.origin + window.location.pathname + "fonts/Basteleur-Bold.otf" 
    }},

    created () {
        window.addEventListener('resize', this.onResize.bind(this));

        $store.firstPage = this.$route.name;

        if (this.$route.name != 'Home') {
            this.hasSeenIntro = true;
        }
    },

    mounted () {
        this.onResize();
    },

    methods: {

        onIntroIsDone (introCardPos) {
            this.introCardPos = introCardPos;
            this.hasSeenIntro = true;
        },

        onResize () {

            let topMarqueeHeight = this.$refs.topMarquee.$el.offsetHeight;
            let bottomMarqueeHeight = this.$refs.bottomMarquee.$el.offsetHeight;
            let windowHeight = window.innerHeight;

            // set appWrapper height
            this.$refs.appWrapper.style.height = (
                (windowHeight - (topMarqueeHeight + bottomMarqueeHeight)) + 'px'
            );

            if (window.innerWidth <= parseFloat(style.cardXsBreakpoint))
                $store.screenSize = 'xs';
            else if (window.innerWidth <= parseFloat(style.cardSBreakpoint))
                $store.screenSize = 's';
            else
                $store.screenSize = 'md';

        }

    }
}
</script>